export class CatalogFilter {
  constructor(name?: string, categoryId?: string, productSkuId?: string) {
    this.name = name;
    this.categoryId = categoryId;
    this.productSkuId = productSkuId;
  }

  name?: string;
  categoryId?: string;
  productSkuId: string;
  isSearchActive: boolean;

  public reset() {
    this.name = null;
    this.categoryId = null;
    this.productSkuId = null;
  }

  public hasValues(): boolean {
    return (
      this.name != null ||
      this.categoryId != null ||
      this.productSkuId != null
    );
  }
}
